import { render, staticRenderFns } from "./SynthesisFilter.vue?vue&type=template&id=4a86ad7c&"
import script from "./SynthesisFilter.vue?vue&type=script&lang=ts&"
export * from "./SynthesisFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports